import { css, Global } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "theme";
import { Button } from "@InnoUI";

const globalStyles = css`
  // .MuiBackdrop-root,
  // MuiDialog-backdrop {
  //   background-color: transparent !important;
  // }
  .MuiDialogContent-root {
    padding: 0px !important;
  }

  .MuiListItemIcon-root {
    min-width: 40px !important;
  }

  .MuiModal-root,
  MuiDialog-root {
    z-index: 2100 !important;
  }

  .MuiDialogTitle-root {
    padding: 0px !important;
  }
  // .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  //   width: 1000px !important;
  // }
`;

const InputField = styled.input`
  width: 85%;
  height: 33px;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid ${theme.colors.bordertask};
  &:focus {
    border-color: ${theme.colors.bordertask};
  }
`;

const DialogContent = styled.div`
  width: 100%;
  min-width: 100%;
`;

const ButtonTag = styled(Button)``;
const DialogTitle = styled.p`
  padding: ${(props) => props.padding || "10px"};
  font-size: ${(props) => props.fontSize || "16px"};
  margin: 0;
  color: white;
  width: 100%;
`;

const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
  InputField,
  DialogContent,
  DialogTitle,
  ButtonTag,
};

export default SC;
